<div class="fixed inset-0 z-[8000] bg-black/50 backdrop-blur-sm" (click)="onClose()"></div>

<div
  class="fixed top-0 right-0 z-[8001] h-dvh w-full max-w-[720px] bg-white dark:bg-surface-1 shadow-2xl flex flex-col"
  (click)="$event.stopPropagation()"
  id="tool_form_panel"
>
  <!-- Header -->
  <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-700/60 shrink-0">
    <div class="flex items-center gap-3">
      <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-sm">
        <svg class="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
      </div>
      <div>
        <h2 class="text-sm font-semibold text-slate-800 dark:text-white">
          {{ (mode === 'edit' ? 'Edit' : 'New') + ' Function Tool' }}
        </h2>
        <p class="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
          {{ mode === 'create' ? 'An API endpoint the live-call assistant can call' : 'Update this function tool' }}
        </p>
      </div>
    </div>
    <button
      (click)="onClose()"
      class="flex items-center justify-center w-8 h-8 rounded-lg text-slate-400 hover:text-slate-700 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors"
      id="tool_form_close_btn"
    >
      <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto px-6 py-5 space-y-5">
    <div
      *ngIf="errorMessage()"
      class="p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-xs text-red-700 dark:text-red-400"
      id="tool_form_error"
    >
      {{ errorMessage() }}
    </div>

    <!-- name + keyname -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Name <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [(ngModel)]="form.tool_name"
          placeholder="Book Appointment"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
                 focus:outline-none focus:ring-2 focus:ring-purple-500/40"
          id="tool_form_name"
        />
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Keyname <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [(ngModel)]="form.tool_keyname"
          [disabled]="mode === 'edit'"
          placeholder="book_appointment"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
                 focus:outline-none focus:ring-2 focus:ring-purple-500/40 disabled:opacity-60 font-mono"
          id="tool_form_keyname"
        />
        <p class="text-[10px] text-slate-400 mt-1">lowercase snake_case — cannot change later</p>
      </div>
    </div>

    <!-- method + endpoint -->
    <div class="grid grid-cols-1 sm:grid-cols-[120px_1fr] gap-4">
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">Method</label>
        <select
          [(ngModel)]="form.method"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500/40"
          id="tool_form_method"
        >
          <option *ngFor="let m of methodOptions" [value]="m">{{ m }}</option>
        </select>
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Endpoint <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [(ngModel)]="form.base_url"
          placeholder="https://… or /path/on/auth-base"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
                 focus:outline-none focus:ring-2 focus:ring-purple-500/40 font-mono"
          id="tool_form_endpoint"
        />
      </div>
    </div>

    <!-- auth -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">Auth</label>
      <select
        [(ngModel)]="form.auth_id"
        [disabled]="authLoading()"
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500/40
               disabled:opacity-60"
        id="tool_form_auth"
      >
        <option [ngValue]="null">– None –</option>
        <option *ngFor="let entry of authOptions()" [ngValue]="entry.id">{{ entry.name }}</option>
      </select>
      <p class="text-[10px] text-slate-400 mt-1">
        {{ authLoading() ? 'Loading auth entries…' : 'The universal credentials this call authenticates with. See the Auth sub-tab.' }}
      </p>
    </div>

    <!-- payload template -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">Payload</label>
      <div class="space-y-2">
        <div *ngFor="let row of payloadRows; let i = index" class="flex items-center gap-2">
          <input type="text" [(ngModel)]="row.key" [name]="'payload_key_' + i" placeholder="key"
                 class="flex-1 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-transparent text-xs" />
          <input type="text" [(ngModel)]="row.value" [name]="'payload_value_' + i" placeholder="value"
                 class="flex-1 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-transparent text-xs" />
          <button type="button" (click)="removePayloadRow(i)"
                  class="p-1.5 rounded-lg text-slate-400 hover:text-red-500" [attr.id]="'tool_form_payload_remove_' + i">
            <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
            </svg>
          </button>
        </div>
        <button type="button" (click)="addPayloadRow()" id="tool_form_payload_add"
                class="text-xs font-semibold text-purple-600 dark:text-purple-400 hover:underline">+ Add Field</button>
      </div>
      <p class="text-[10px] text-slate-400 mt-1">A flat key→value template sent with every call. Leave empty for none.</p>
    </div>

    <!-- description -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">Description</label>
      <textarea
        [(ngModel)]="form.description"
        rows="3"
        placeholder="What this tool does and when the assistant should call it."
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
               focus:outline-none focus:ring-2 focus:ring-purple-500/40 resize-none"
        id="tool_form_description"
      ></textarea>
    </div>

    <!-- agent assignments -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">Used by assistants</label>
      <app-agent-multi-select
        [selected]="form.agent_ids"
        (selectedChange)="form.agent_ids = $event"
      ></app-agent-multi-select>
      <p class="text-[10px] text-slate-400 mt-1">
        The assistants (prompt templates) that can call this tool. A tool with none selected is used by <strong>no assistant</strong>.
      </p>
    </div>

    <!-- is_active -->
    <label
      class="flex items-start gap-3 p-3 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer
             hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors"
    >
      <input
        type="checkbox"
        [(ngModel)]="form.is_active"
        class="mt-0.5 w-4 h-4 rounded accent-emerald-600"
        id="tool_form_is_active"
      />
      <span>
        <span class="block text-xs font-semibold text-slate-700 dark:text-slate-200">Active</span>
        <span class="block text-[10px] text-slate-400 mt-0.5">
          Inactive tools are kept here but not callable by the assistant.
        </span>
      </span>
    </label>
  </div>

  <!-- Footer -->
  <div class="flex gap-3 px-6 py-4 border-t border-slate-100 dark:border-slate-700/60 shrink-0">
    <button
      (click)="onClose()"
      class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium
             text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors"
      id="tool_form_cancel_btn"
    >
      Cancel
    </button>
    <button
      (click)="onSubmit()"
      [disabled]="submitting()"
      class="flex-1 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-purple-500 to-indigo-600
             hover:from-purple-600 hover:to-indigo-700 disabled:opacity-60 transition-all active:scale-95"
      id="tool_form_submit_btn"
    >
      <span *ngIf="!submitting()">{{ mode === 'create' ? 'Create Tool' : 'Save Changes' }}</span>
      <span *ngIf="submitting()" class="flex items-center justify-center gap-2">
        <span class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
        Saving…
      </span>
    </button>
  </div>
</div>
